import { ReactNode } from 'react';
import { handleTrack } from '../../../../../utils/tracker';
import { Button, ButtonVariants } from '../../../../Atoms/Button';
import { appendOrCreateQueryParam } from '../../../../Header/utils';
import { setITRLocalStorage } from '../../../../itr2/static/utils';

interface ISTICKY_BUTTON_PROPS {
  buttonText: string | ReactNode;
  trackLabel: string;
  buttonLink?: string;
  onClickHandler?: (e: React.MouseEvent | React.TouchEvent) => void;
  isStickyOnMobile?: boolean;
  buttonVariant?: ButtonVariants;
  className?: string;
  value?: string;
  target?: string;
}
export const ButtonWithAnchor = ({
  buttonText,
  trackLabel,
  buttonLink,
  onClickHandler,
  buttonVariant,
  className,
  isStickyOnMobile = false,
  value,
  target = '_self',
}: ISTICKY_BUTTON_PROPS): JSX.Element => {
  const buttonLinkWithUtm = buttonLink
    ? appendOrCreateQueryParam(
        buttonLink,
        'utm_ref',
        `${trackLabel}_${buttonText}`
      )
    : buttonLink;

  return (
    <div
      className={`w-full  sm:w-full ${
        isStickyOnMobile
          ? 'sm:bg-white sm:p-4 sm:fixed sm:bottom-0 sm:left-0 sm:z-30 sm:w-full text-center sm:shadow-lg w-[238px] '
          : ''
      }`}
    >
      <a
        href={buttonLinkWithUtm}
        target={target}
        onClick={(e) => {
          setITRLocalStorage(buttonLinkWithUtm);
          handleTrack({
            label: trackLabel,
            url: buttonLink,
            obj: e.target,
            value: value,
          });
          if (typeof onClickHandler === 'function') {
            onClickHandler(e);
          }
        }}
        className="w-full"
      >
        <Button
          variant={buttonVariant}
          rounded="sm"
          className={`w-full ${className || ''}`}
        >
          {buttonText}
        </Button>
      </a>
    </div>
  );
};
